import {
  AngleMode,
  CuttingFacadeOutline,
  CuttingMaterial,
  CuttingPanelBaseSlot,
  CuttingPanelOutline,
  MasonsMitreOrientationEnum,
  OutlineAngle,
  OutlineEditorOptions,
  PanelBase,
} from 'cloud-shared-lib';
import * as _ from 'lodash';

export enum PositionMaxSize {
  TopLeft,
  TopRight,
  BottomRight,
  BottomLeft,
}

export class CornerProcessingHelper {
  static topLeftMax(
    outline: CuttingPanelOutline<CuttingPanelBaseSlot> | CuttingFacadeOutline,
    panel: PanelBase
  ): { x: number; y: number } {
    const topLeftXMax =
      panel.height -
      Math.max(
        +outline.topRight.rounding,
        +outline.topRight.roundingInside,
        +outline.topRight.cutInsideX,
        +outline.topRight.cutX,
        outline.topRight.mode === AngleMode.DiagonalCut ? +panel.width : 0,
        Math.floor(Math.sqrt(Math.pow(outline.topRight.chamferLength, 2) / 2))
      );

    const topLeftYMax =
      panel.width -
      Math.max(
        +outline.bottomLeft.rounding,
        +outline.bottomLeft.roundingInside,
        +outline.bottomLeft.cutInsideY,
        +outline.bottomLeft.cutY,
        outline.bottomLeft.mode === AngleMode.DiagonalCut ? +panel.height : 0,
        Math.floor(Math.sqrt(Math.pow(outline.bottomLeft.chamferLength, 2) / 2))
      );

    return { x: topLeftXMax, y: topLeftYMax };
  }

  static topRightMax(
    outline: CuttingPanelOutline<CuttingPanelBaseSlot> | CuttingFacadeOutline,
    panel: PanelBase
  ): { x: number; y: number } {
    const topRightYMax =
      panel.width -
      Math.max(
        outline.bottomRight.rounding,
        outline.bottomRight.roundingInside,
        outline.bottomRight.cutInsideY,
        outline.bottomRight.cutY,
        outline.bottomRight.mode === AngleMode.DiagonalCut ? panel.height : 0,
        Math.floor(Math.sqrt(Math.pow(outline.bottomRight.chamferLength, 2) / 2))
      );

    const topRightXMax =
      panel.height -
      Math.max(
        outline.topLeft.rounding,
        outline.topLeft.roundingInside,
        outline.topLeft.cutInsideX,
        outline.topLeft.cutX,
        outline.topLeft.mode === AngleMode.DiagonalCut ? panel.width : 0,
        Math.floor(Math.sqrt(Math.pow(outline.topLeft.chamferLength, 2) / 2))
      );

    return { x: topRightXMax, y: topRightYMax };
  }

  static bottomRightMax(
    outline: CuttingPanelOutline<CuttingPanelBaseSlot> | CuttingFacadeOutline,
    panel: PanelBase
  ): { x: number; y: number } {
    const bottomRightYMax =
      panel.width -
      Math.max(
        outline.topRight.rounding,
        outline.topRight.roundingInside,
        outline.topRight.cutInsideY,
        outline.topRight.cutY,
        outline.topRight.mode === AngleMode.DiagonalCut ? panel.height : 0,
        Math.floor(Math.sqrt(Math.pow(outline.topRight.chamferLength, 2) / 2))
      );

    const bottomRightXMax =
      panel.height -
      Math.max(
        outline.bottomLeft.rounding,
        outline.bottomLeft.roundingInside,
        outline.bottomLeft.cutInsideX,
        outline.bottomLeft.cutX,
        outline.bottomLeft.mode === AngleMode.DiagonalCut ? panel.width : 0,
        Math.floor(Math.sqrt(Math.pow(outline.bottomLeft.chamferLength, 2) / 2))
      );

    return { x: bottomRightXMax, y: bottomRightYMax };
  }

  static bottomLeftMax(
    outline: CuttingPanelOutline<CuttingPanelBaseSlot> | CuttingFacadeOutline,
    panel: PanelBase
  ): { x: number; y: number } {
    const bottomLeftYMax =
      panel.width -
      Math.max(
        outline.topLeft.rounding,
        outline.topLeft.roundingInside,
        outline.topLeft.cutInsideY,
        outline.topLeft.cutY,
        outline.topLeft.mode === AngleMode.DiagonalCut ? panel.height : 0,
        Math.floor(Math.sqrt(Math.pow(outline.topLeft.chamferLength, 2) / 2))
      );

    const bottomLeftXMax =
      panel.height -
      Math.max(
        outline.bottomRight.rounding,
        outline.bottomRight.roundingInside,
        outline.bottomRight.cutInsideX,
        outline.bottomRight.cutX,
        outline.bottomRight.mode === AngleMode.DiagonalCut ? panel.width : 0,
        Math.floor(Math.sqrt(Math.pow(outline.bottomRight.chamferLength, 2) / 2))
      );

    return { x: bottomLeftXMax, y: bottomLeftYMax };
  }

  static getAllXMax(
    outline: CuttingPanelOutline<CuttingPanelBaseSlot> | CuttingFacadeOutline,
    panel: PanelBase
  ): [number, number, number, number] {
    const topLeftXMax =
      panel.height -
      Math.max(
        +outline.topRight.rounding,
        +outline.topRight.roundingInside,
        +outline.topRight.cutInsideX,
        +outline.topRight.cutX,
        outline.topRight.mode === AngleMode.DiagonalCut ? +panel.width : 0,
        Math.floor(Math.sqrt(Math.pow(outline.topRight.chamferLength, 2) / 2))
      );

    const topRightXMax =
      panel.height -
      Math.max(
        outline.topLeft.rounding,
        outline.topLeft.roundingInside,
        outline.topLeft.cutInsideX,
        outline.topLeft.cutX,
        outline.topLeft.mode === AngleMode.DiagonalCut ? panel.width : 0,
        Math.floor(Math.sqrt(Math.pow(outline.topLeft.chamferLength, 2) / 2))
      );

    const bottomRightXMax =
      panel.height -
      Math.max(
        outline.bottomLeft.rounding,
        outline.bottomLeft.roundingInside,
        outline.bottomLeft.cutInsideX,
        outline.bottomLeft.cutX,
        outline.bottomLeft.mode === AngleMode.DiagonalCut ? panel.width : 0,
        Math.floor(Math.sqrt(Math.pow(outline.bottomLeft.chamferLength, 2) / 2))
      );

    const bottomLeftXMax =
      panel.height -
      Math.max(
        outline.bottomRight.rounding,
        outline.bottomRight.roundingInside,
        outline.bottomRight.cutInsideX,
        outline.bottomRight.cutX,
        outline.bottomRight.mode === AngleMode.DiagonalCut ? panel.width : 0,
        Math.floor(Math.sqrt(Math.pow(outline.bottomRight.chamferLength, 2) / 2))
      );

    return [topLeftXMax, topRightXMax, bottomRightXMax, bottomLeftXMax];
  }

  static getAllYMax(
    outline: CuttingPanelOutline<CuttingPanelBaseSlot> | CuttingFacadeOutline,
    panel: PanelBase
  ): [number, number, number, number] {
    const topLeftYMax =
      panel.width -
      Math.max(
        +outline.bottomLeft.rounding,
        +outline.bottomLeft.roundingInside,
        +outline.bottomLeft.cutInsideY,
        +outline.bottomLeft.cutY,
        outline.bottomLeft.mode === AngleMode.DiagonalCut ? +panel.height : 0,
        Math.floor(Math.sqrt(Math.pow(outline.bottomLeft.chamferLength, 2) / 2))
      );

    const topRightYMax =
      panel.width -
      Math.max(
        outline.bottomRight.rounding,
        outline.bottomRight.roundingInside,
        outline.bottomRight.cutInsideY,
        outline.bottomRight.cutY,
        outline.bottomRight.mode === AngleMode.DiagonalCut ? panel.height : 0,
        Math.floor(Math.sqrt(Math.pow(outline.bottomRight.chamferLength, 2) / 2))
      );

    const bottomRightYMax =
      panel.width -
      Math.max(
        outline.topRight.rounding,
        outline.topRight.roundingInside,
        outline.topRight.cutInsideY,
        outline.topRight.cutY,
        outline.topRight.mode === AngleMode.DiagonalCut ? panel.height : 0,
        Math.floor(Math.sqrt(Math.pow(outline.topRight.chamferLength, 2) / 2))
      );

    const bottomLeftYMax =
      panel.width -
      Math.max(
        outline.topLeft.rounding,
        outline.topLeft.roundingInside,
        outline.topLeft.cutInsideY,
        outline.topLeft.cutY,
        outline.topLeft.mode === AngleMode.DiagonalCut ? panel.height : 0,
        Math.floor(Math.sqrt(Math.pow(outline.topLeft.chamferLength, 2) / 2))
      );

    return [topLeftYMax, topRightYMax, bottomRightYMax, bottomLeftYMax];
  }

  static possibilityCornerProcessing(materials: CuttingMaterial[], outlineOptions: OutlineEditorOptions): boolean {
    let isWrongCornerProcessing = false;

    _.each(materials, m => {
      _.each(m.panels, p => {
        const allXMax = this.getAllXMax(p.panelOutline, p);
        const allYMax = this.getAllYMax(p.panelOutline, p);

        if (p.panelOutline.topLeft.mode !== AngleMode.None) {
          isWrongCornerProcessing ||= this.checkIsWrongCornerProcessing(
            p.panelOutline.topLeft,
            allXMax[PositionMaxSize.TopLeft],
            allYMax[PositionMaxSize.TopLeft],
            outlineOptions
          );
        }
        if (p.panelOutline.topRight.mode !== AngleMode.None) {
          isWrongCornerProcessing ||= this.checkIsWrongCornerProcessing(
            p.panelOutline.topRight,
            allXMax[PositionMaxSize.TopRight],
            allYMax[PositionMaxSize.TopRight],
            outlineOptions
          );
        }
        if (p.panelOutline.bottomLeft.mode !== AngleMode.None) {
          isWrongCornerProcessing ||= this.checkIsWrongCornerProcessing(
            p.panelOutline.bottomLeft,
            allXMax[PositionMaxSize.BottomLeft],
            allYMax[PositionMaxSize.BottomLeft],
            outlineOptions
          );
        }
        if (p.panelOutline.bottomRight.mode !== AngleMode.None) {
          isWrongCornerProcessing ||= this.checkIsWrongCornerProcessing(
            p.panelOutline.bottomRight,
            allXMax[PositionMaxSize.BottomRight],
            allYMax[PositionMaxSize.BottomRight],
            outlineOptions
          );
        }

        if (isWrongCornerProcessing) {
          return false;
        }
      });

      if (isWrongCornerProcessing) {
        return false;
      }
    });

    return isWrongCornerProcessing;
  }

  private static checkIsWrongCornerProcessing(
    outlineAngle: OutlineAngle,
    XMax: number,
    YMax: number,
    outlineOptions: OutlineEditorOptions
  ): boolean {
    switch (outlineAngle.mode) {
      case AngleMode.Rounded:
        if (outlineAngle.rounding > Math.min(XMax, YMax, outlineOptions.angles.rounding.restrictions.max)) {
          return true;
        }
        return false;
      case AngleMode.Cutted:
        if (
          outlineAngle.cutX > Math.min(XMax, outlineOptions.angles.cutting.restrictions.max) ||
          outlineAngle.cutY > Math.min(YMax, outlineOptions.angles.cutting.restrictions.max)
        ) {
          return true;
        }
        return false;
      case AngleMode.RoundedInside:
        if (outlineAngle.roundingInside > Math.min(XMax, YMax, outlineOptions.angles.insideRounding.restrictions.max)) {
          return true;
        }
        return false;
      case AngleMode.CuttedInside:
        if (
          outlineAngle.cutInsideX > Math.min(XMax, outlineOptions.angles.insideCutting.restrictions.max) ||
          outlineAngle.cutInsideY > Math.min(YMax, outlineOptions.angles.insideCutting.restrictions.max) ||
          outlineAngle.cutInsideR > outlineOptions.angles.insideCutting.restrictions.radiusMax
        ) {
          return true;
        }
        return false;
      case AngleMode.CuttedInsideWithAngle:
        return (
          outlineAngle.cutInsideWithAngle.x >
            Math.min(XMax, outlineOptions.angles.insideCuttingWithAngle.restrictions.max) ||
          outlineAngle.cutInsideWithAngle.y >
            Math.min(YMax, outlineOptions.angles.insideCuttingWithAngle.restrictions.max) ||
          outlineAngle.cutInsideWithAngle.r > outlineOptions.angles.insideCuttingWithAngle.restrictions.radiusMax
        );
      case AngleMode.Chamfer:
        if (outlineAngle.chamferLength > Math.min(XMax, YMax, outlineOptions.angles.chamfer.restrictions.max)) {
          return true;
        }
        return false;
      case AngleMode.MasonsMitreFemale:
        if (
          outlineAngle.masonsMitreFemale.length >
          (outlineAngle.masonsMitreFemale.orientation === MasonsMitreOrientationEnum.AlongHeight ? XMax : YMax)
        ) {
          return true;
        }
        return false;
    }
  }
}
